/* CAPSUL3 — theme interactions */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* Mobile menu ---------------------------------------------------------- */
  var menu = $('[data-mobile-menu]');
  var menuOpenBtn = $('[data-menu-open]');

  function setMenu(open) {
    if (!menu) return;
    menu.dataset.open = open ? 'true' : 'false';
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
    if (menuOpenBtn) menuOpenBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  if (menuOpenBtn) {
    menuOpenBtn.addEventListener('click', function () { setMenu(true); });
  }
  $$('[data-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { setMenu(false); });
  });
  $$('[data-menu-link]').forEach(function (link) {
    link.addEventListener('click', function () { setMenu(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu && menu.dataset.open === 'true') setMenu(false);
  });

  /* Sticky header -------------------------------------------------------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Reveal on scroll ----------------------------------------------------- */
  var reveals = $$('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Countdown ------------------------------------------------------------ */
  $$('[data-countdown]').forEach(function (el, index) {
    var hours = parseFloat(el.dataset.hours || '24');
    if (!hours || hours < 1) hours = 24;
    var key = 'capsul3-offer-end-' + index;
    var end = 0;
    try { end = parseInt(window.localStorage.getItem(key), 10) || 0; } catch (e) {}
    if (!end || end < Date.now()) {
      end = Date.now() + hours * 3600 * 1000;
      try { window.localStorage.setItem(key, String(end)); } catch (e) {}
    }

    var out = {
      days: el.querySelector('[data-countdown-days]'),
      hours: el.querySelector('[data-countdown-hours]'),
      minutes: el.querySelector('[data-countdown-minutes]'),
      seconds: el.querySelector('[data-countdown-seconds]')
    };
    if (!out.days) return;

    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var total = Math.floor(diff / 1000);
      var d = Math.floor(total / 86400);
      var h = Math.floor((total % 86400) / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      out.days.textContent = pad(d);
      out.hours.textContent = pad(h);
      out.minutes.textContent = pad(m);
      out.seconds.textContent = pad(s);
      if (diff === 0) {
        try { window.localStorage.removeItem(key); } catch (e) {}
      }
    }
    tick();
    window.setInterval(tick, 1000);
  });

  /* Product carousel ----------------------------------------------------- */
  $$('[data-carousel]').forEach(function (root) {
    var slides = $$('[data-slide]', root);
    if (!slides.length) return;
    var dots = $$('[data-dot]', root);
    var counter = $('[data-carousel-index]', root);
    var current = 0;

    function show(n) {
      current = (n + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.dataset.active = active ? 'true' : 'false';
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        var active = i === current;
        dot.dataset.active = active ? 'true' : 'false';
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (counter) {
        var pad = current + 1 < 10 ? '0' + (current + 1) : String(current + 1);
        counter.textContent = pad;
      }
    }

    $$('[data-prev]', root).forEach(function (btn) {
      btn.addEventListener('click', function () { show(current - 1); });
    });
    $$('[data-next]', root).forEach(function (btn) {
      btn.addEventListener('click', function () { show(current + 1); });
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); });
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
    });

    var startX = null;
    var stage = $('.carousel__stage', root);
    if (stage) {
      stage.addEventListener('touchstart', function (e) {
        startX = e.changedTouches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 40) show(current + (delta < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });
    }

    show(0);
  });

  /* Technical details ---------------------------------------------------- */
  $$('[data-details]').forEach(function (root) {
    var triggers = $$('[data-detail-trigger]', root);
    var panels = $$('[data-detail-panel]', root);
    var media = $$('[data-detail-media]', root);
    var progress = $$('[data-detail-progress]', root);
    var specValue = $('[data-detail-spec-value]', root);
    var specLabel = $('[data-detail-spec-label]', root);
    if (!triggers.length) return;

    function activate(index) {
      triggers.forEach(function (trigger, i) {
        var active = i === index;
        trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
      });
      panels.forEach(function (panel, i) { panel.hidden = i !== index; });
      media.forEach(function (img, i) { img.dataset.active = i === index ? 'true' : 'false'; });
      progress.forEach(function (bar, i) { bar.dataset.active = i === index ? 'true' : 'false'; });
      var trigger = triggers[index];
      if (trigger) {
        if (specValue) specValue.textContent = trigger.dataset.specValue || '';
        if (specLabel) specLabel.textContent = trigger.dataset.specLabel || '';
      }
    }

    triggers.forEach(function (trigger, i) {
      trigger.addEventListener('click', function () { activate(i); });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          var next = (i + 1) % triggers.length;
          triggers[next].focus();
          activate(next);
        }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var prev = (i - 1 + triggers.length) % triggers.length;
          triggers[prev].focus();
          activate(prev);
        }
      });
    });
  });

  /* Accordions: only one open ------------------------------------------- */
  $$('[data-accordion]').forEach(function (group) {
    var items = $$('details', group);
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  });

  /* Product page: variants, quantity and gallery ------------------------- */
  var pdp = $('[data-product]');
  if (pdp) {
    var variants = [];
    var dataEl = $('[data-variants]');
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }

    var selected = {};
    $$('[data-option-index]', pdp).forEach(function (group) {
      var idx = group.dataset.optionIndex;
      var btns = $$('[data-option-value]', group);
      btns.forEach(function (btn) {
        if (btn.dataset.selected === 'true') selected[idx] = btn.dataset.optionValue;
        btn.addEventListener('click', function () {
          btns.forEach(function (other) {
            other.dataset.selected = 'false';
            other.setAttribute('aria-pressed', 'false');
          });
          btn.dataset.selected = 'true';
          btn.setAttribute('aria-pressed', 'true');
          selected[idx] = btn.dataset.optionValue;
          var label = group.querySelector('[data-option-label]');
          if (label) label.textContent = btn.dataset.optionValue;
          syncVariant();
        });
      });
    });

    function currentVariant() {
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options;
        var ok = true;
        for (var key in selected) {
          if (opts[parseInt(key, 10)] !== selected[key]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function syncVariant() {
      var variant = currentVariant();
      var idInput = $('[data-variant-id]', pdp);
      var priceEl = $('[data-price]', pdp);
      var compareEl = $('[data-compare]', pdp);
      var saveEl = $('[data-save]', pdp);
      var addBtn = $('[data-add]', pdp);
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Agotado'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price_formatted;
      if (compareEl) {
        if (variant.compare_at_price_formatted) {
          compareEl.textContent = variant.compare_at_price_formatted;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (saveEl) {
        if (variant.save_formatted) {
          saveEl.textContent = 'Ahorra ' + variant.save_formatted;
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? (addBtn.dataset.labelAdd || 'Añadir al carrito') : 'Agotado';
      }
      if (variant.featured_media_id) {
        var thumb = $('[data-thumb="' + variant.featured_media_id + '"]', pdp);
        if (thumb) thumb.click();
      }
    }

    var qtyInput = $('[data-qty]', pdp);
    $$('[data-qty-plus]', pdp).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (qtyInput) qtyInput.value = Math.min(99, (parseInt(qtyInput.value, 10) || 1) + 1);
      });
    });
    $$('[data-qty-minus]', pdp).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (qtyInput) qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
    });

    var mainImg = $('[data-main-image]', pdp);
    $$('[data-thumb]', pdp).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        $$('[data-thumb]', pdp).forEach(function (other) { other.dataset.active = 'false'; });
        thumb.dataset.active = 'true';
        if (mainImg && thumb.dataset.src) {
          mainImg.src = thumb.dataset.src;
          mainImg.srcset = '';
        }
      });
    });

    syncVariant();
  }

  /* Cart quantity steppers ---------------------------------------------- */
  $$('[data-cart-minus], [data-cart-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      if (!input) return;
      var value = parseInt(input.value, 10) || 1;
      input.value = btn.hasAttribute('data-cart-plus') ? value + 1 : Math.max(0, value - 1);
    });
  });
})();
